import { inject, view } from "@spawn/core";
import { DEFAULT_LAYER_PRIORITY, GoldenBonusMetadataKeys, GoldenBonusService } from "@spawn/golden-bonus";
import { RevealSymbolSpotlightView } from "@spawn/reveal";
import { IShowSymbolsOnSpotlightPayload, SymbolModel } from "@spawn/slot-machine";

@view
export class GameSymbolSpotlightView extends RevealSymbolSpotlightView {
	@inject protected readonly goldenBonusService!: GoldenBonusService;

	protected override initialize(): void {
		this.zOrderingEnabled = true;
		super.initialize();
	}

	protected override show({
		symbolCoordinates,
		disableDimming,
		symbolMetaDataKeys = [],
		loopAnimations,
	}: IShowSymbolsOnSpotlightPayload): void {
		// The golden bonus feature brings its own dimming layer.
		if (!this.goldenBonusService.isFeatureActive) {
			if (disableDimming === true) {
				void this.dimmingLayer.hide();
			} else {
				void this.dimmingLayer.show();
			}
		}

		// Show only symbols that are in win positions.
		for (const symbolCoordinate of symbolCoordinates) {
			const winSymbol = this.symbolList[symbolCoordinate.y][symbolCoordinate.x];
			winSymbol.zIndex = this.calculateLayerPriority(winSymbol.symbolModel);
			winSymbol.visible = true;
			winSymbol.setMetaDataActive({ symbolMetaDataKeys, loopAnimations });
		}
	}

	private calculateLayerPriority(symbolModel: SymbolModel): number {
		return symbolModel.getMetaData<number | undefined>(GoldenBonusMetadataKeys.LayerPriority) ?? DEFAULT_LAYER_PRIORITY;
	}
}
